import { ObjetKStatus } from '@siclop/kstone-vue'

export class EmployeeSchedule extends ObjetKStatus {
  employeeId: number = 0
  workScheduleTemplateId: number = 0
  startDate: string = ''
  endDate?: string
  notes: string = ''
  templateName?: string

  constructor(data?: Partial<EmployeeSchedule>) {
    super(data)
    if (data) {
      this.employeeId = data.employeeId ?? 0
      this.workScheduleTemplateId = data.workScheduleTemplateId ?? 0
      this.startDate = data.startDate ?? ''
      this.endDate = data.endDate
      this.notes = data.notes ?? ''
      this.templateName = data.templateName
    }
  }
}
